///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/gadget/data"/>
import * as serialization from "Core/Medius.Core.Web/Scripts/Medius/lib/serialization";
import * as rpc from "Core/Medius.Core.Web/Scripts/Medius/core/rpc";

export class Data {
    getDataAsync: any;
    constructor() {
        this.getDataAsync = function(serviceName:string, functionName:string, params:any) {
            const request = rpc.ajax(serviceName, functionName, {
                    data: serialization.toJSON(params)
                }
            );

            return request;
        };
    }
}